import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import AppBarBase from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import MenuItemBase from '@mui/material/MenuItem';
import DrawerBase from '@mui/material/Drawer';
import ListItemTextBase from '@mui/material/ListItemText';

import { Icon } from '@components/icon';

const drawerWidth = 332;

export const AppBar = styled(AppBarBase).attrs({
  elevation: 0,
})``;

export const ListItemText = styled(ListItemTextBase).attrs({
  sx: { fontFamily: 'Mukta', fontSize: 24, fontWeight: 400 },
})``;

export const MenuHeader = styled(Box).attrs({
  p: 1.2,
})`
  background: ${({ theme }) => theme.gradients.secondary};
`;


export const Content = styled(Box) <{ drawerOpen: boolean; isMobile?: boolean }>`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  padding: 0px 32px;
  transition: padding-left 0.3s ease, background-color 0.3s ease, color 0.3s ease;
  padding-left: calc(${(props) => (props.drawerOpen && !props.isMobile ? '332px' : '0px')} + 32px);
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
`;


export const Drawer = styled(DrawerBase).attrs({
  elevation: 0,
  sx: {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      bgcolor: 'background.paper',
      color: 'text.primary',
      borderRight: '1px solid',
      borderColor: 'divider',
      transition: 'background-color 0.3s ease, border-color 0.3s ease',
    },
  },
})``;

export const HeaderItems = styled(Box).attrs({
  sx: { display: { xs: 'none', md: 'flex', alignItems: 'center' } },
})``;

export const HeaderMenuIcon = styled(Box).attrs({
  sx: { display: { xs: 'flex', md: 'none', alignItems: 'flex-start' } },
})``;

export const MenuItem = styled(MenuItemBase).attrs({
  sx: { mt: 2, mb: 2 },
})`
  font-family: Mukta;
`;

export const LogoWrapper = styled(Grid).attrs({
  p: 5,
  container: true,
  justifyContent: 'center',
})`
  background: ${({ theme }) => theme.gradients.secondary};
`;

export const LogoIcon = styled.img.attrs(({ theme }) => ({
  src: theme.media.logos.main,
  alt: 'Logo Icone',
}))<{ src?: string; alt?: string }>`
  width: 16rem;
`;
